export default "__VITE_ASSET__74792b0b__"